import { z } from 'zod';

export const MILEAGE_UNIT_VALUES = ['Kilometres', 'Miles'] as const;
export const MILEAGE_UNIT_VALUES_LOWERCASE = ['kilometres', 'miles'] as const;

export const mileageUnitSchema = z.enum(MILEAGE_UNIT_VALUES);
export const mileageUnitLowercaseSchema = z.enum(MILEAGE_UNIT_VALUES_LOWERCASE);

export const minMaxSchema = z.object({
  min: z.number(),
  max: z.number(),
});

export const vehicleDetailsSchema = z.object({
  bodyType: z.string(),
  colour: z.string(),
  engineCapacityInCc: z.number(),
  fuelType: z.string(),
  make: z.string(),
  model: z.string(),
  noOfOwners: z.number(),
  registrationNumber: z.string(),
  transmission: z.string(),
  yearOfManufacture: z.string(),
  mileage: z.number(),
  mileageUnit: mileageUnitSchema,
});

export type MinMaxValue = z.infer<typeof minMaxSchema>;
export type VehicleDetails = z.infer<typeof vehicleDetailsSchema>;
export type MileageUnits = z.infer<typeof mileageUnitSchema>;
export type MileageUnitsLowercase = z.infer<typeof mileageUnitLowercaseSchema>;
